import { CustomBoxV2 } from "components";
import { BunkerIcon } from "pages/internal-dashboard/icons";

export function Bunker({ data, loading, percentages }: any) {
  return (
    <CustomBoxV2
      loading={loading}
      color="#BFD0F2"
      title="Bunker"
      userCount={data?.total || 0}
      boxData={{
        label: "Bunker",

        todayCount: data?.day || 0,
        weekCount: data?.week || 0,
        monthCount: data?.month || 0,
        yearCount: data?.year || 0,
        icon: BunkerIcon,
      }}
      percentages={percentages}
    />
  );
}
